// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__3SBgk","LayoutContent":"Layout_LayoutContent__YkCec","slide-container":"Layout_slide-container__1N0Lv"};